export default {
  slug: "rustrover",
  code: "RR",
  label: "RustRover",
  isIDE: true,
  krakenDir: "RustRover",
  thumbnailColor: "#21D789",
  logoFamily: "ide",
};
